import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { UserAccountInfo } from '@lub0v/santa-utils';
import { Button, Hint, Spinner, Stack } from '@src/components';
import { santaClient } from '@src/state/client';
import { EmailField } from './EmailField';

/** Uses the same verified email-linking flow as permanent account settings. */
export function GuestEmailLink() {
  const { t } = useTranslation();
  const [account, setAccount] = useState<UserAccountInfo | null>(null);
  const [challengeToken, setChallengeToken] = useState('');
  const [failed, setFailed] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    void santaClient.account().then((res) => {
      if (!active) return;
      if (!res.ok || !res.data) {
        setFailed(true);
        return;
      }
      setAccount(res.data);
      const otp = (res.data as UserAccountInfo & { otpChallenge?: { challengeToken?: string } })
        .otpChallenge;
      setChallengeToken(otp?.challengeToken || '');
    }).catch(() => {
      if (active) setFailed(true);
    });
    return () => {
      active = false;
    };
  }, [attempt]);
  if (failed) return (
    <Stack gap={3}>
      <Hint>{t('switcher.actionError')}</Hint>
      <Button
        variant="secondary"
        onClick={() => {
          setFailed(false);
          setAttempt((value) => value + 1);
        }}
      >
        {t('account.guestEmailRetry')}
      </Button>
    </Stack>
  );
  if (!account) return <Spinner label={t('account.loading')} />;
  return (
    <EmailField
      guest
      account={account}
      challengeToken={challengeToken}
      onAccountChange={(next, token) => {
        setAccount(next);
        setChallengeToken(token);
      }}
    />
  );
}
